import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Container, Box, Button, IconButton,
  Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  MenuBook, Home, Info, Menu as MenuIcon, Close,
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { colors } from '../styles/theme';

const NAV_ITEMS = [
  { label: '首页', path: '/', icon: <Home /> },
  { label: '关于项目', path: '/about', icon: <Info /> },
];

function Navbar() {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <AppBar position="sticky" elevation={0} sx={{
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid rgba(0,0,0,0.06)',
      }}>
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 0 } }}>
            {/* Logo */}
            <Box
              component={Link}
              to="/"
              sx={{
                display: 'flex', alignItems: 'center', gap: 1.5,
                textDecoration: 'none', color: 'inherit',
              }}
            >
              <Box sx={{
                width: 36, height: 36, borderRadius: 2,
                background: `linear-gradient(135deg, ${colors.primary.main}, ${colors.primary.light})`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <MenuBook sx={{ fontSize: 20, color: 'white' }} />
              </Box>
              <Box>
                <Typography sx={{
                  fontWeight: 700, fontSize: '1rem', lineHeight: 1.2,
                  fontFamily: '"Noto Serif SC", serif', color: colors.text.primary,
                }}>
                  中文热词国际新闻报道检索
                </Typography>
                <Typography sx={{
                  fontSize: '0.65rem', color: colors.text.muted, lineHeight: 1,
                  display: { xs: 'none', sm: 'block' },
                }}>
                  Chinese Buzzwords in International News Database
                </Typography>
              </Box>
            </Box>

            {/* Desktop Nav */}
            {!isMobile && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {NAV_ITEMS.map((item) => (
                  <Button
                    key={item.path}
                    component={Link}
                    to={item.path}
                    startIcon={item.icon}
                    sx={{
                      color: isActive(item.path) ? colors.primary.main : colors.text.secondary,
                      fontWeight: isActive(item.path) ? 600 : 400,
                      backgroundColor: isActive(item.path) ? `${colors.primary.main}08` : 'transparent',
                      borderRadius: 2, px: 2, py: 0.8,
                      fontSize: '0.9rem',
                      '&:hover': {
                        backgroundColor: `${colors.primary.main}10`,
                        color: colors.primary.main,
                      },
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
              </Box>
            )}

            {/* Mobile Menu Button */}
            {isMobile && (
              <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: colors.text.primary }}>
                <MenuIcon />
              </IconButton>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 260, pt: 1 } }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1 }}>
          <Typography sx={{ fontWeight: 600, fontFamily: '"Noto Serif SC", serif' }}>导航</Typography>
          <IconButton onClick={() => setDrawerOpen(false)}><Close /></IconButton>
        </Box>
        <Divider />
        <List>
          {NAV_ITEMS.map((item) => (
            <ListItem
              key={item.path}
              component={Link}
              to={item.path}
              onClick={() => setDrawerOpen(false)}
              sx={{
                color: isActive(item.path) ? colors.primary.main : colors.text.primary,
                backgroundColor: isActive(item.path) ? `${colors.primary.main}08` : 'transparent',
                '&:hover': { backgroundColor: `${colors.primary.main}10` },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 40 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} primaryTypographyProps={{
                fontWeight: isActive(item.path) ? 600 : 400,
              }} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}

export default Navbar;
